import { buildHref } from "@softmax/web-addresses";
import { site } from "@softmax/web-addresses/discovery";
import type { PreviewContent } from "../content/preview-content.types";

export function previewHead(content: PreviewContent) {
  const canonical = `${site.canonicalOrigin}${buildHref({ name: "game.preview", ...content.route })}`;
  const title = `${content.name} · Softmax`;
  return {
    meta: [
      { title },
      { name: "description", content: content.blurb },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonical },
      { property: "og:title", content: title },
      { property: "og:description", content: content.blurb },
      {
        property: "og:image",
        content: `${site.canonicalOrigin}${buildHref({ name: "game.previewImage", ...content.route })}`,
      },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: `${content.name} on Softmax` },
    ],
    links: [
      { rel: "canonical", href: canonical },
      {
        rel: "alternate",
        type: "text/markdown",
        href: buildHref({ name: "game.playMarkdown", ...content.route }),
      },
    ],
  };
}
